/**
 * Factory: salesChannels
 */
angular.module('acme.common.factory.salesChannels', [])
.factory('SalesChannelsFactory', [function() {


  function SalesChannels() {

    return {

      constructor: SalesChannels,

      init: function () {
        return this.generate();
      },

      generate: function() {
        return [
          {
            name: 'Web',
            channel: 'online',
            enabled: true
          },
          {
            name: "Point of Sale",
            channel: "pointOfSale",
            enabled: true
          },
          {
            name: "Reseller",
            channel: "reseller",
            enabled: true
          },
          {
            name: "Customer Rep",
            channel: "customerRep",
            enabled: true
          },
          {
            name: "Manual Entry",
            channel: "manualEntry",
            enabled: true
          },
          {
            name: "Kiosk",
            channel: "kiosk",
            enabled: true
          }
        ];
      },

      normalize: function(salesChannels) {
        var i, ii,
          channels = [],
          _channels = [],
          order = ['online', 'pointOfSale', 'reseller', 'customerRep', 'manualEntry', 'kiosk'];

        if (salesChannels instanceof Array) {
          for (i=0,ii=salesChannels.length;i<ii;i++) {
            if (order.length && order[0] == salesChannels[i].channel) {
              channels.push(salesChannels[i]);
              order.shift();
            }else{
              _channels.push(salesChannels[i]);
            }
          }

          salesChannels = channels.concat(_channels);
        }

        return salesChannels;
      }


    };

  }

  return SalesChannels;

}]);